import styled from "styled-components";
import { Radio, Upload } from "antd";
import { COLORS } from "../../../../../layout/theme/colors/Colors";
import { Button, Table } from "antd";
import { WEIGHT } from "../../../../../layout/theme";

export const Buttons = styled.div`
	${(props) =>
		!props.clientId
			? `
      display: flex;
      width: 100%;
      justify-content: end;
      position: absolute;
      transform: translateY(-86px);
      & button {
        padding: 0 !important;
      }

      @media only screen and (min-width: 760px) and (max-width: 1200px) {
        flex-direction: column;
        height: 150px;
      }
  `
			: `
    display: flex;
    width: 100%;
    justify-content: start;
    & button {
      padding: 0 !important;
    }
  `}
`;

export const ButtonsLeft = styled.div`
	display: flex;
	gap: 20px;
`;

export const UploadFile = styled(Upload)`
	width: 150px;
	height: 32px;
	font-size: 16px;
	display: flex;
	justify-content: center;
	background-color: ${COLORS.Secondary};
	color: ${COLORS.White};
	align-items: center;
	border: 1px solid ${COLORS.Secondary};
	border-radius: 10px;
	padding: 0.5rem 0;
	cursor: pointer;
	&:hover {
		background-color: ${COLORS.Secondary};
	}
	& span {
		color: ${COLORS.White};
	}
`;

export const AntdButton = styled(Button)`
	width: 150px;
	height: 40px;
	background-color: ${(props) =>
		props.success ? COLORS.Success : COLORS.Default};
	color: ${COLORS.White};
	border: 1px solid
		${(props) => (props.success ? COLORS.Success : COLORS.Default)};
	border-radius: 7px;
	padding: 0.5rem 0;
	&:hover {
		background-color: ${(props) =>
			props.success ? COLORS.Success : COLORS.Default};
	}
	& span {
		color: ${COLORS.White};
	}
`;

export const AntdTable = styled(Table)`
	& .hasChanges,
	& .hasChanges:hover {
		color: ${COLORS.White} !important;
		background-color: ${COLORS.Default} !important;
	}

  .ant-table-thead > tr > th {
    background: ${(props) => (props.background ? props.background : COLORS.Primary)};
  }

  .ant-table-row {
    background: ${(props) => (props.rowBackground ? props.rowBackground : COLORS.White)};
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${(props) => (props.background ? props.background : COLORS.Primary)};

    div {
      color: ${(props) => (props.background ? props.background : COLORS.Primary)};
    }
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-radius: 20px 0 0 0;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-radius: 0 20px 0 0;
  }

  }
`;

export const TableContainer = styled.div`
	margin-top: 30px;

	.ant-table table {
		background-color: ${(props) =>
			props.containerBackground
				? props.containerBackground
				: COLORS.LightGrey} !important;
	}
`;

export const ConfirmButton = styled.div`
	${(props) =>
		!props.clientId
			? `
	display: flex;
	justify-content: end;
	margin: 20px 0;`
			: `display: flex;
	justify-content: start;
	margin: 0px 0;`}
`;

export const SpanCointainer = styled.div`
	${(props) => (!props.clientId ? `margin: 60px 0;` : `margin: 30px`)}
`;
export const Span = styled.span`
	cursor: pointer;
	color: ${COLORS.Secondary};
	margin-right: 60px;
	font-weight: ${WEIGHT.ExtraBold};
`;

export const RadioOptions = styled.div`
	display: flex;
	margin-top: 20px;
	margin-bottom: 20px;
	align-items: center;

	.ant-radio-group {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	.ant-btn {
		border-radius: 10px !important;
	}
`;

export const AntdRadioButton = styled(Radio.Button)`
	border: 1px solid #e5e7eb !important;
	border-radius: 10px !important;
	font-weight: ${WEIGHT.Bold};
	background: #ffffff !important;
	color: #6b7280 !important;
	box-shadow: none !important;

	&.ant-radio-button-wrapper-checked {
		background: #eef2ff !important;
		border-color: #c7d2fe !important;
		color: #3730a3 !important;
	}

	&:before {
		display: none !important;
	}
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector {
		height: 40px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const Section = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

export const TableWrapper = styled.div`
	width: 100%;
	border-radius: 20px;
	overflow: hidden;
`;
